import { graphql } from "react-apollo";
import { FlightScheduleImport } from "../../../queries/FlightScheduleImport";

const withSingleFlightImportData = graphql(FlightScheduleImport, {
  options: ({ match }) => ({
    variables: {
      id: match.params.id
    }
  }),
  props: ({ data: { flightScheduleImport } }) => ({
    flightScheduleImport
  })
});

export default withSingleFlightImportData;



// WEBPACK FOOTER //
// ./src/component/Maintenance/ImportFlights/withSingleFlightImportData.js